const LIQUID_ENGINE = 'liquid_engine';

/**
 * Calculates whethet a gig is relevant for the rising talent A/B/C test or not.
 * @param  {String} [gigType=''] The gig's type.
 * @param  {Object} abTests      A flat object, where each key represents the test's name, and the value the user's variant.
 * @return {Boolean|Number}      Either "false", or the test variation;
 */
export function getRisingTalentExpVariation(gigType = '', abTests) {
    if (gigType === LIQUID_ENGINE && abTests) {
        const variant = abTests.GIG_CARDS_RISING_TALENT;

        return variant && variant !== 1 ? variant : false;
    }

    return false;
}



// WEBPACK FOOTER //
// ./src/utils/variants/index.js